interface Props {
  value: number
  unit: string
  language: string
  alpha2: string
}

export const getRelativeTimeFormat = ({
  value,
  unit,
  language,
  alpha2,
}: Props) => {
  const rtf = new Intl.RelativeTimeFormat(`${language}-${alpha2}`, {
    numeric: 'auto',
  })
  const relativeTimeFormat = rtf.format(
    value,
    unit as Intl.RelativeTimeFormatUnit,
  )
  return (
    relativeTimeFormat.charAt(0).toUpperCase() + relativeTimeFormat.slice(1)
  )
}
